import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import ReactDateRangePicker from 'react-bootstrap-daterangepicker';
import withFormsyValidations from 'flaivy-react/components/withFormsyValidations';
import { propTypes } from 'formsy-react';
import moment from 'moment';
import _ from 'lodash';

class DateRangePicker extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      setValue: PropTypes.func.isRequired,
      rangeOnly: PropTypes.bool,
      value: PropTypes.array,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      value: [],
      rangeOnly: false,
    };
  }

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event, picker) {
    const { name, setValue, onChange } = this.props;

    const { currentTarget } = event;

    if (currentTarget.name === 'thenOrWhen') {
      const value = currentTarget.value === 'between' ? [] : 'currentTimestamp';
      setValue({ [currentTarget.value]: value }, false); // this is the performance thief
      onChange(name, { [currentTarget.value]: value });
      return;
    }

    if (event.type !== 'apply') return;
    const startDate = _.get(picker, 'startDate')
      ? _.get(picker, 'startDate').format('YYYY-MM-DD')
      : undefined;
    const endDate = _.get(picker, 'endDate')
      ? _.get(picker, 'endDate').format('YYYY-MM-DD')
      : undefined;
    const value = { between: [startDate, endDate] };
    setValue(value, false); // this is the performance thief
    onChange(name, value);
  }

  render() {
    // Dont remove onChange from below.
    const { value, name, rangeOnly } = this.props;

    const { between } = value || {};
    const selector = Object.keys(value || {})[0];

    const selectedValue =
      selector === 'between'
        ? `${_.get(between, '[0]', ' ')} - ${_.get(between, '[1]', ' ')}`
        : '';

    return (
      <>
        {!rangeOnly && (
          <Input
            type="select"
            name="thenOrWhen"
            value={selector}
            onChange={this.changeValue}
          >
            <option value="between">Mellan valda datum</option>
            <option value="lte">i dåtiden</option>
            <option value="gte">i framtiden</option>
          </Input>
        )}

        <div
          className={
            selector !== 'lte' && selector !== 'gte' ? 'visible' : 'invisible'
          }
        >
          <ReactDateRangePicker
            showISOWeekNumbers
            initialSettings={{
              locale: { format: 'yyyy-MM-DD', firstDay: 1 },
              autoUpdateInput: false,
              showISOWeekNumbers: true,
              ranges: {
                Idag: [moment(), moment()],
                Igår: [
                  moment().subtract(1, 'days'),
                  moment().subtract(1, 'days'),
                ],
                'Senaste 7 dagarna': [moment().subtract(6, 'days'), moment()],
                'Senaste 30 dagarna': [moment().subtract(29, 'days'), moment()],
                'Nuvarande månad': [
                  moment().startOf('month'),
                  moment().endOf('month'),
                ],
                'Förra månaden': [
                  moment().subtract(1, 'month').startOf('month'),
                  moment().subtract(1, 'month').endOf('month'),
                ],
                'I år': [moment().startOf('year'), moment().endOf('year')],
                'Förra året': [
                  moment().subtract(1, 'year').startOf('year'),
                  moment().subtract(1, 'year').endOf('year'),
                ],
              },
              alwaysShowCalendars: true,
              showCustomRangeLabel: false,
            }}
            onEvent={this.changeValue}
          >
            <input
              type="text"
              className="form-control"
              id={name}
              value={selectedValue}
            />
          </ReactDateRangePicker>
        </div>
      </>
    );
  }
}

export default withFormsyValidations(DateRangePicker);
